import { render, staticRenderFns } from "./RowItemDocument.vue?vue&type=template&id=4f092330&scoped=true&"
import script from "./RowItemDocument.vue?vue&type=script&lang=js&"
export * from "./RowItemDocument.vue?vue&type=script&lang=js&"
import style0 from "./RowItemDocument.vue?vue&type=style&index=0&id=4f092330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f092330",
  null
  
)

export default component.exports